import * as React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { queryClient } from '@/lib/queryClient';
import { env } from '@/lib/env';

// Router basename from Vite base (ADR-023 Option B): subdomain build '/' → '/';
// workspace build base '/operations/' → '/operations'. Same app serves
// zafroi.com AND app.zafroi.com/operations/.
const ROUTER_BASENAME = import.meta.env.BASE_URL.replace(/\/+$/, '') || '/';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={ROUTER_BASENAME}>
        <TooltipProvider delayDuration={200}>{children}</TooltipProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton expand visibleToasts={4} />
      {env.isDev && <ReactQueryDevtools buttonPosition="bottom-right" />}
    </QueryClientProvider>
  );
}
